(function () {
  document.addEventListener('click', function (e) {
    var cover = e.target.closest('.fwvb-cover');
    if (!cover) return;

    var id = cover.dataset.youtubeId;
    if (!id) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'ratio ratio-16x9 fwvb-player';
    wrapper.innerHTML =
      '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" ' +
      'frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

    cover.replaceWith(wrapper);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var cover = e.target.closest('.fwvb-cover');
    if (!cover) return;
    e.preventDefault();
    cover.click();
  });
})();
